import { render } from "./Ship_fingers.vue?vue&type=template&id=07b66cf9"
import script from "./Ship_fingers.vue?vue&type=script&lang=js"
export * from "./Ship_fingers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__